import {
  Card,
  CardContent,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography
} from '@mui/material'
import { LabelField } from 'components'
import { Chip } from 'components/chips'
import { InboundTripDto } from 'dtos'
import { formatDate } from 'utils'

interface InboundTripsListCardProps {
  inboundTrip: InboundTripDto
}

export default function InboundTripsListCard({ children, inboundTrip }: React.PropsWithChildren<InboundTripsListCardProps>) {
  return (
    <Card>
      <CardContent>
        <Grid container alignItems='flex-start'>
          <Grid item xs={12} sm={5} container>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm='auto' container alignItems='center'>
                <Grid item>
                  <Typography fontWeight='bold' variant='h5'>
                    Inbound Trip #{inboundTrip.inboundTripNumber}
                  </Typography>
                </Grid>

                <Grid item>
                  <Chip variant={inboundTrip.isLocked ? 'red' : 'green'}>{inboundTrip.isLocked ? 'Locked' : 'Unlocked'}</Chip>
                </Grid>
              </Grid>

              <Grid item xs={12} sm='auto'>
                {children}
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={12}>
              <LabelField
                label='Inbound Transporter Company'
                value={inboundTrip.inboundTransporterCompany?.name}
                to={`/companies/${inboundTrip.inboundTransporterCompany?.companyGuid}`}
              />
            </Grid>

            {/*
            This does not make sense being here, as it cannot be set in any release?
            Maxwell Sommer 10/09/2024
            */}
            <Grid item xs={12}>
              <LabelField
                label='Buyer'
                value={
                  inboundTrip.inboundTripPAPS?.length > 0 && inboundTrip.inboundTripPAPS[0].buyerCompany
                    ? inboundTrip.inboundTripPAPS[0].buyerCompany.name
                    : ''
                }
              />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Entry #' value={inboundTrip.entryNumber} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Entry Date' value={inboundTrip.entryDate ? formatDate(inboundTrip.entryDate) : ''} />
            </Grid>
          </Grid>

          <Grid item xs={12} sm={7}>
            <TableContainer>
              <Table>
                <TableBody>
                  {inboundTrip.inboundTripPAPS?.map((inboundTripPAPS, index) => (
                    <TableRow sx={{ backgroundColor: index % 2 === 0 ? '#FCFCFD' : 'white' }}>
                      <TableCell width={'25%'}>
                        PAPS #{inboundTripPAPS.papsNumber}{' '}
                        {inboundTripPAPS.isLocked ? <Chip variant='red'>Locked</Chip> : <Chip variant='green'>Unlocked</Chip>}
                      </TableCell>

                      <TableCell width={'25%'}>{inboundTripPAPS.exporterCompany?.name}</TableCell>

                      <TableCell width={'50%'}>
                        <Table>
                          <TableBody>
                            {inboundTripPAPS.vehicles?.map((vehicle, j) => (
                              <TableRow>
                                <TableCell
                                  sx={{ borderBottom: j === (inboundTripPAPS.vehicles?.length ?? 0) - 1 ? 'none' : '' }}
                                >
                                  {vehicle.vin}
                                </TableCell>

                                <TableCell
                                  sx={{ borderBottom: j === (inboundTripPAPS.vehicles?.length ?? 0) - 1 ? 'none' : '' }}
                                >
                                  {vehicle.year}
                                </TableCell>

                                <TableCell
                                  sx={{ borderBottom: j === (inboundTripPAPS.vehicles?.length ?? 0) - 1 ? 'none' : '' }}
                                >
                                  {vehicle.make}
                                </TableCell>

                                <TableCell
                                  sx={{ borderBottom: j === (inboundTripPAPS.vehicles?.length ?? 0) - 1 ? 'none' : '' }}
                                >
                                  {vehicle.model}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
